/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Seats_InvalidInputs */



/**
* | output |
* | --- |
* | "At least one seat." |
*
* @param {Partner_Add_Customer_Contract_Seats_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_seats_invalid = /** @type {((inputs?: Partner_Add_Customer_Contract_Seats_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Seats_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestens ein Platz.")
	return /** @type {LocalizedString} */ ("At least one seat.")
});